import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import SyncIcon from '@mui/icons-material/Sync';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import { tokens } from "../../../../theme";
import PopoverModal from "../../../theme/Modal/PopoverModal";
import { ActionButton } from "./components/ActionButton";
import { ActionIcon } from "./components/ActionIcon";
import Text from "../../../theme/text/Text";
import { Lock } from "@mui/icons-material";

const AMRelationdata = (props) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const colors = tokens(theme.palette.mode);

    const isFulfilment = props.isFulfilment;

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    // Check if the webshop is active - handle both 'active' boolean and 'state' string
    const isActive = props.webshopCredsData?.active === true || 
                     props.webshopCredsData?.active === 'true' ||
                     props.webshopCredsData?.state === 'active';

    const syncProducts = () => {
        props.syncProducts();
        props.onClose();
    };

    const syncStock = () => {
        props.syncStock();
        props.onClose();
    };

    return (
        <PopoverModal
            {...props}
        >
            <Box 
                sx={{
                    background: theme.palette.mode === "dark" ? colors.grey[100] : "#fff",
                    padding: 1.5,
                    paddingBottom: isStandAlone ? 4 : 1.5,
                    display: "flex",
                    gap: 1,
                    flexDirection: "column",
                    borderRadius: "24px",
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    "@media screen and (max-width: 48em)": {
                        borderRadius: "32px",
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                    }
                }}
            >
                <ActionButton onClick={syncProducts}>
                    <ActionIcon>
                        <SyncIcon fontSize="small"/>
                    </ActionIcon>
                    <Box>
                        <Text>
                            {t('sync_products')}
                        </Text>
                    </Box>
                </ActionButton>

                <ActionButton onClick={syncStock}>
                    <ActionIcon>
                        <SyncIcon fontSize="small"/>
                    </ActionIcon>
                    <Box>
                        <Text>
                            {t('sync_stock')}
                        </Text>
                    </Box>
                </ActionButton>

            </Box>
        </PopoverModal>
    );
};

export default AMRelationdata; 